import { render } from "./KryptonPopinButton.vue?vue&type=template&id=bfaad4f6&lang=pug"
import script from "./KryptonPopinButton.vue?vue&type=script&lang=js"
export * from "./KryptonPopinButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__